export { AiBorderDirective } from '@catch/directives';
